import { Fragment } from "react";

import { cn } from "../../../../assets/Utils/generic";

import IconBookmark from "../../../../assets/icons/IconBookmark";

// Skeleton Card Component
const SkeletonCard = ({ isxLargeScreen }: { isxLargeScreen: boolean }) => {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: isxLargeScreen ? "row" : "column",
          padding: "15px",
          backgroundColor: "#fff",
          gap: "15px",
        }}
        className="rounded"
      >
        <div
          style={{
            flex: "0 0 270px",
            height: "270px",
            borderRadius: "20px",
            backgroundColor: "#e0e0e0",
            animation: "pulse 1.5s infinite",
          }}
        ></div>
        <div
          style={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <div
            style={{
              height: "15px",
              backgroundColor: "#e0e0e0",
              borderRadius: "5px",
              animation: "pulse 1.5s infinite",
            }}
          ></div>
          <div
            style={{
              height: "24px",
              width: "60%",
              backgroundColor: "#e0e0e0",
              borderRadius: "5px",
              animation: "pulse 1.5s infinite",
            }}
          ></div>
          <div
            style={{
              height: "20px",
              backgroundColor: "#e0e0e0",
              borderRadius: "5px",
              animation: "pulse 1.5s infinite",
            }}
          ></div>
        </div>
        <div
          style={{
            flex: "0 0 150px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            borderLeft: isxLargeScreen ? "1px solid #eee" : "",
          }}
        >
          <div
            style={{
              height: "15px",
              width: "60%",
              backgroundColor: "#e0e0e0",
              borderRadius: "5px",
              animation: "pulse 1.5s infinite",
            }}
          ></div>
          <div
            style={{
              width: "80%",
              height: "30px",
              backgroundColor: "#e0e0e0",
              borderRadius: "5px",
              animation: "pulse 1.5s infinite",
            }}
          ></div>
        </div>
      </div>
      <div className="bg-[#ddd] h-[1px] my-[10px]"></div>
    </>
  );
};

// Main Component to Render Skeletons
export default function ResultSkeletonList({
  isxLargeScreen,
}: {
  isxLargeScreen: boolean;
}) {
  return (
    <div className="flex flex-col gap-8 lg:gap-8 sm:gap-0 xl:gap-0 w-full">
      {Array.from({ length: 5 }).map((_, index) => (
        <Fragment key={index}>
          <div className="px-4">
            <div className="flex flex-col gap-4 sm:flex-row xl:flex-row lg:flex-col sm:p-3 xl:p-3 lg:p-0 sm:rounded-2xl xl:rounded-2xl lg:rounded-none">
              <div className="relative rounded-2xl w-full h-[17.313rem] sm:size-[256px] xl:size-[256px] lg:w-full lg:h-[17.313rem] border-none box-border bg-[#D1D1D1] ring-4 ring-white shadow-xl overflow-hidden sm:ring-0 xl:ring-0 lg:ring-4 shrink-0 sm:shadow-none xl:shadow-none lg:shadow-xl animate-pulse">
                <div className="absolute left-1/2 -translate-x-1/2 bottom-4 sm:bottom-2 xl:bottom-2 flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, paginationIndex) => (
                    <div
                      key={index}
                      className={cn(
                        "rounded-full size-1.5 bg-[#D1D1D1] animate-pulse",
                        paginationIndex === 0 && "bg-[#D1D1D1]",
                      )}
                    />
                  ))}
                </div>
              </div>
              <div className="flex flex-col w-full sm:h-[14.375rem] xl:h-[14.375rem] lg:h-auto sm:pl-2 xl:pl-2 lg:pl-0">
                <div className="flex items-center justify-between">
                  <div className="w-1/3 h-7 animate-pulse bg-[#D1D1D1] rounded-xl" />
                </div>
                <div className="flex flex-col">
                  <div className="w-1/2 h-5 lg:h-5 animate-pulse bg-[#D1D1D1] rounded-xl mt-2 shrink-0 sm:h-3.5 xl:h-3.5" />
                </div>
                <div className="flex flex-col gap-2 h-full">
                  <div className="flex justify-between items-end w-full sm:flex-col xl:flex-col lg:flex-row sm:items-start xl:items-start lg:items-end sm:flex-1 xl:flex-1 lg:flex-auto">
                    <div className="w-1/6 h-7 animate-pulse bg-[#D1D1D1] rounded-xl mt-2" />
                    <div className="w-full sm:flex-1 xl:flex-1 lg:flex-auto" />
                    <div className="w-1/4 h-7 animate-pulse bg-[#D1D1D1] rounded-xl ml-auto" />
                  </div>
                  <div className="items-center justify-end gap-2 ml-auto mt-1 w-full hidden lg:hidden sm:flex xl:flex">
                    <div className="h-12 animate-pulse bg-[#D1D1D1] rounded-[0.875rem] w-4/12" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-hide={index === Array.from({ length: 5 }).length - 1}
            className="lg:px-0 sm:px-4 xl:px-4 data-[hide=true]:hidden mt-2.5"
          >
            <div className="bg-[#D1D1D1] h-[0.375rem] lg:bg-[#D1D1D1] lg:h-[0.375rem] sm:my-5 xl:my-5 sm:bg-[#E8E8E8] sm:h-px xl:bg-[#E8E8E8] xl:h-px" />
          </div>
        </Fragment>
      ))}
    </div>
  );
}

// // Add a keyframes animation for the pulse effect
// const pulseAnimation = `
//   @keyframes pulse {
//     0% {
//       background-color: #e0e0e0;
//     }
//     50% {
//       background-color: #f0f0f0;
//     }
//     100% {
//       background-color: #e0e0e0;
//     }
//   }
// `;

// // Inject animation into the document's <style> tag
// const styleTag = document.createElement("style");
// styleTag.innerHTML = pulseAnimation;
// document.head.appendChild(styleTag);
